<template>
  <div style="font-size: 0.85rem" class="text-white left-[45px] leading-[17px] mb-2">
    {{ $t('bulk_scan') }}
  </div>
  <el-switch @change="handleSwitchChange" v-model="_isMultipleScan" />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { PropSync } from 'vue-property-decorator'
@Options({
  emits: ['update:isMultipleScan'],
  name: 'BulkScanSwitchButton',
})
export default class BulkScanSwitchButton extends Vue {
  @PropSync('isMultipleScan', { type: Boolean, default: true }) _isMultipleScan!: boolean

  handleSwitchChange(value: boolean) {
    this.$emit('update:isMultipleScan', value)
  }
}
</script>
